<div class="modal-header blue">
  <h4 class="modal-title">Add Account(s) to user</h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<form [formGroup]="accountsFiltersForm">
  <div class="modal-body flex-container">
    <div class="mb-3 pb-2" [class.disabled]="isLoading">
      <div class="form-row md">
        <div class="col-5">
          <span class="input-label">Enter Name</span>
          <input
            type="text"
            class="input"
            placeholder="Name"
            formControlName="name"
          />
        </div>

        <div class="col-5">
          <span class="input-label">Account Number</span>
          <input
            type="text"
            class="input"
            placeholder="Enter Group ID"
            formControlName="accountNumber"
          />
        </div>

        <div class="col-2">
          <button
            class="button-outline w-100"
            (click)="doSearch()"
            [disabled]="accountsFiltersForm.invalid"
          >
            Search
          </button>
        </div>
      </div>
    </div>

    <div [class.loading]="isLoading">
      <accounts-to-user-grid
        [userApplications]="userApplications"
        [userAccounts]="checkedAccounts"
        [isFromModal]="true"
        [searchParams]="searchParams"
        (accountsCheck)="setAccounts($event)"
      >
      </accounts-to-user-grid>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="button w-134px ml-auto"
      (click)="addGroups()"
      [disabled]="!checkedAccounts?.length"
    >
      Add Accounts
    </button>
  </div>
</form>
